// extracted by mini-css-extract-plugin
export default {"container":"BaseAccordion_container__A+CHX","title":"BaseAccordion_title__-OcrE","counter":"BaseAccordion_counter__O2OID"};